function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 12h4M15 12h4M12 15v4M12 5v4M11.02 40v14.084c0 .532.377.989.899 1.089l19.605 3.78c.163.036.329.046.495.046.226 0 .44-.036.654-.082l26.562-6.721c.461-.115.785-.53.785-1.005V36.4M40.017 16.926L21.685 18.81a1.455 1.455 0 00-1.046.617L7.54 38.7",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.844 19.191l13.254 20.391a3.117 3.117 0 003.224 1.357l23.291-4.658a1.748 1.748 0 001.075-2.74L49.341 16.46a1.056 1.056 0 00-.98-.454l-2.34.308M32.02 43v16M16.02 55.964V42.883a1.883 1.883 0 012.117-1.868l5.706.713a2.485 2.485 0 012.177 2.466v13.698",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.02 23v-8.981c0-.563.456-1.019 1.019-1.019h3.962c.563 0 1.019.456 1.019 1.019V26",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgDestination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/destination.svg";
export { SvgDestination as ReactComponent };